<template>
    <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:999999;">
        <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
            <div class="absolute inset-0 bg-black opacity-75"></div>
        </div>
        <div class="bg-white overflow-hidden shadow-xl transform transition-all sm:max-w-3xl sm:w-full max-h- overflow-y-auto hide-scrollbar" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
                <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="$emit('close')">
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="sm:flex sm:items-start border-b border-gray-400">
                    <div class="mt-3 text-center sm:mt-0 sm:text-left">
                        <h3 class="text-lg leading-6 font-medium text-black pb-2" id="modal-headline">
                            <slot name="heading">{{ type }} Task</slot>
                        </h3>
                    </div>
                </div>
                <tabs :tabs="tabs" ref="tabs" v-if="type === 'View'" :dynamic="false" @setTab="setModalTab"></tabs>
                <ValidationObserver ref="form" v-slot="{ invalid }">
                    <div class="flex md:flex-row sm:flex-col">
                        <div class="w-full mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12" v-if="type!=='View'">
                            <div class="col-span-12 bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
                            <div class="col-span-12 bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>
                            <input-select class="sm:col-span-4"
                                label="Type"
                                placeholder="Type"
                                name="type"
                                v-model="item.type_id"
                                :initial-value="initialValue.type"
                                return="value"
                                rules="required"
                                :required="true"
                                :options="options.types"/>
                            <input-select class="sm:col-span-4"
                                label="Priority"
                                placeholder="Priority"
                                name="priority"
                                v-model="item.priority_id"
                                :initial-value="initialValue.priority"
                                return="value"
                                rules="required"
                                :required="true"
                                :options="options.priorities"/>
                            <input-select class="sm:col-span-4"
                                label="Status"
                                placeholder="Status"
                                name="status"
                                v-model="item.status_id"
                                :initial-value="initialValue.status"
                                return="value"
                                rules="required"
                                :required="true"
                                :options="options.statuses"/>
                            <input-select class="sm:col-span-4"
                                label="Project"
                                placeholder="Project"
                                name="project"
                                v-model="item.project_id"
                                :initial-value="initialValue.project"
                                return="value"
                                :required="false"
                                :options="options.projects"/>
                            <input-date-time
                                class="sm:col-span-12 md:col-span-12 lg:col-span-4"
                                label="Due Date"
                                placeholder="Due Date"
                                name="due_date"
                                v-model="item.due_date"
                                :initial-value="initialValue.due_date"
                                :watch-initial="true"
                                type="datetime"
                                format="dd/LL/yyyy h:mm a"
                                :auto="true"
                                rules="required"
                                :required="true"
                                :minuteStep="15"
                                :use12Hour="true"/>
                            <input-select class="sm:col-span-4"
                                placeholder="Search ..."
                                label="Assigned To"
                                name="assignee_id"
                                v-model="item.assignee_id"
                                :initial-value="initialValue.assignee"
                                return="value"
                                endpoint="users"
                                type="system"
                                endpointLabelField="full_name_reversed"
                                ref="assignee"/>
                            <input-text class="sm:col-span-12"
                                label="Subject"
                                placeholder="Subject"
                                name="subject"
                                v-model="item.subject"
                                rules="required"
                                :required="true" />
                            <input-textarea class="sm:col-span-12"
                                label="Description"
                                placeholder="Description"
                                name="description"
                                v-model="item.description"
                                :required="false" />
                            <div class="col-span-12">
                                <h2 class="w-full sm:col-span-12 pb-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900 mb-3">Documents/Files</h2>
                                <span v-for="(file, index) in files" class="text-base mb-1 flex flex-row items-center my-2">
                                    <a :href="S3URL + '/' + file.path " target="_blank" class="text-gray-800 hover:text-default-500 truncate">{{ file.filename }}</a>
                                    <button type="button" @click="removeUploadFile(index)">
                                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="times" class="svg-inline--fa fa-times w-6 h-6 text-red-700 ml-2" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                            <path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path>
                                        </svg>
                                    </button>
                                </span>
                                <FileUpload @uploaded="fileUploaded($event)"/>
                            </div>
                        </div>
                        <div class="xl:w-full lg:w-full md:w-full sm:w-full px-4 sm:px-2 lg:px-2 bg-white border-r border-l border-b border-gray-400 bg-gray-200" v-if="type==='View'" v-show="startTab === 'details'">
                            <table class="w-full mb-4 internal-table">
                                <thead>
                                    <tr>
                                        <th colspan="2">Task Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Assignee</td>
                                        <td>{{ item.assignee ? item.assignee.name : '' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="w-32 font-black">Due Date</td>
                                        <td>{{ new Date(item.due_date) | moment("DD/MM/YYYY h:mm a") }}</td>
                                    </tr>
                                    <tr>
                                        <td>Type</td>
                                        <td v-if="item.type">
                                            {{ item.type.name }}
                                        </td>
                                        <td v-else>N/A</td>
                                    </tr>
                                    <tr>
                                        <td>Status</td>
                                        <td v-if="item.status">
                                            {{ item.status.name }}
                                        </td>
                                        <td v-else>N/A</td>
                                    </tr>
                                    <tr>
                                        <td>Priority</td>
                                        <td v-if="item.priority">
                                            {{ item.priority.name }}
                                        </td>
                                        <td v-else>N/A</td>
                                    </tr>
                                    <tr>
                                        <td>Project</td>
                                        <td v-if="item.project">
                                            {{ item.project.name }}
                                        </td>
                                        <td v-else>N/A</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="sm:col-span-12" v-if="files && files.length > 0">
                                <table class="w-full mb-4 internal-table">
                                    <thead>
                                    <tr>
                                        <th>Documents/Files</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(file, index) in files" :key="index">
                                        <td style="font-weight: normal;"><a :href="s3URL + '/' + file.path " target="_blank" class="text-gray-800 hover:text-default-500 truncate">{{ file.filename }}</a></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                         <div class="w-full" v-if="type==='View'" v-show="startTab === 'notes'">
                            <notes
                                :id="item.id"
                                :notes="item.notes"
                                model="Task"
                                :scroll="true"
                            />
                        </div>
                    </div>
                </ValidationObserver>
            </div>
            <div class="bg-gray-200 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" v-if="type === 'View'">
                    <button type="button" class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        @click="type='Edit'">
                        <slot name="delete-button">Edit Task</slot>
                     </button>
                 </span>
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" v-if="type !== 'View'">
                    <button type="button" class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        @click="submit()">
                        <slot name="delete-button">Save</slot>
                     </button>
                 </span>
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        @click="$emit('close')">
                    Cancel
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import Tabs from "@/mixins/Tabs";
    import Notes from "@/components/Notes";

    export default {
        name: "TaskFormModal",
        props: {
            model: { required: false, default: null },
            id: { required: false, default: null },
            task: { required: false, default: null },
            view: { required: false, default: null }
        },
        components: {
            Notes
        },
        mixins: [
            Tabs
        ],
        mounted() {
            document.body.className = 'overflow-hidden';

            if (this.task){
                this.item = this.task
                this.files = this.task.files
                this.type = !this.view ? 'Edit' : this.view;

                if(this.type === 'View'){
                    this.startTab = 'details'
                    this.setActiveTab('details')
                }
            }
        },
        destroyed() {
            this.item = {};
            this.type = 'New';
        },
        data: function () {
            return {
                item: {},
                type: 'New',
                submitted: false,
                errorMessage: '',
                options: {
                    types: [],
                    statuses: [],
                    priorities: [],
                    projects: [],
                },
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    },
                    {
                        name: 'Notes',
                        slug: 'notes'
                    }
                ],
                startTab: 'details',
                S3URL: process.env.VUE_APP_S3_URL,
                files: []
            }
        },
        methods: {
            submit: function () {
                this.$store.commit('TOGGLE_BACKDROP', {open: true});

                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;
                    this.errorMessage = '';

                    let _url;
                    let _method;

                    if (this.item.id) {
                        _url = process.env.VUE_APP_API_URL + '/tasks/' + this.item.id;
                        _method = 'PUT';
                    } else {
                        _url = process.env.VUE_APP_API_URL + '/tasks';
                        _method = 'POST';
                    }

                    this.item.model = {
                        id: this.id,
                        model: this.model
                    }

                    this.item.files = this.files

                    axios({
                        method: _method,
                        url: _url,
                        data: this.item
                    }).then(response => {
                        if (response.data.success) {
                            if (_method === 'PUT'){
                                this.$emit('updated', response.data.data);
                            } else {
                                this.$emit('saved', response.data.data);
                            }

                            this.$notify({
                                group: 'main',
                                type: 'success',
                                title: 'Success',
                                text: response.data.message,
                                duration: 5000
                            });
                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                        }
                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }
                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
            setModalTab: function(value){
                this.startTab = value;
            },
            fileUploaded(payload) {
                payload.data.forEach(file => {
                    this.files.push(file)
                })
            },
            removeUploadFile(index){
                this.files.splice(index, 1)
            },
        },
        beforeMount() {
            // Types
            if (this.$store.getters.taskTypes.length === 0) {
                this.$store.dispatch('GET_TASK_TYPES').then(() => {
                    this.options.types = this.$store.getters.taskTypes.map(function (type) {
                        return {label: type.name, value: type.id};
                    });
                });
            } else {
                this.options.types = this.$store.getters.taskTypes.map(function (type) {
                    return {label: type.name, value: type.id};
                });
            }

            // Priorities
            if (this.$store.getters.taskPriorities.length === 0) {
                this.$store.dispatch('GET_TASK_PRIORITIES').then(() => {
                    this.options.priorities = this.$store.getters.taskPriorities.map(function (type) {
                        return {label: type.name, value: type.id};
                    });
                });
            } else {
                this.options.priorities = this.$store.getters.taskPriorities.map(function (type) {
                    return {label: type.name, value: type.id};
                });
            }

            // Statuses
            if (this.$store.getters.taskStatuses.length === 0) {
                this.$store.dispatch('GET_TASK_STATUSES').then(() => {
                    this.options.statuses = this.$store.getters.taskStatuses.map(function (type) {
                        return {label: type.name, value: type.id};
                    });
                });
            } else {
                this.options.statuses = this.$store.getters.taskStatuses.map(function (type) {
                    return {label: type.name, value: type.id};
                });
            }

            // Projects
            if (this.$store.getters.taskProjects.length === 0) {
                this.$store.dispatch('GET_TASK_PROJECTS').then(() => {
                    this.options.projects = this.$store.getters.taskProjects.map(function (project) {
                        return {label: project.name, value: project.id};
                    });
                });
            } else {
                this.options.projects = this.$store.getters.taskProjects.map(function (project) {
                    return {label: project.name, value: project.id};
                });
            }
        },
        computed: {
            initialValue: function(){
                let output = {};

                if (this.task && this.task.status){
                    output['status'] = this.task.status.id;
                } else {
                    if (this.$store.getters.taskStatuses && this.$store.getters.taskStatuses.length > 0) {
                        output['status'] = this.$store.getters.taskStatuses.filter(status => {
                            if (status.name === 'Open') {
                                return status.id;
                            } else {
                                return false;
                            }
                        })[0].id;
                    } else {
                        output['status'] = null
                    }
                }

                if (this.task && this.task.priority){
                    output['priority'] = this.task.priority.id;
                } else {
                    if (this.$store.getters.taskPriorities && this.$store.getters.taskPriorities.length > 0) {
                        output['priority'] = this.$store.getters.taskPriorities.filter(priority => {
                            if (priority.name === 'Normal') {
                                return priority.id;
                            } else {
                                return false;
                            }
                        })[0].id;
                    } else {
                        output['priority'] = null
                    }
                }

                if (this.task && this.task.assignee){
                    output['assignee'] = { value: this.task.assignee.id, label: this.task.assignee.name };
                }

                if (this.task && this.task.type){
                    output['type'] = this.task.type.id;
                }

                if (this.item && this.item.project){
                    output['project'] = this.item.project.id;
                }

                if (this.task && this.item.due_date){
                    output['due_date'] = this.item.due_date;
                } else {
                    output['due_date'] = null;
                }

                return output;
            },
        }
    }
</script>

<style scoped>

</style>
